var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe_wrapper_1"},[_c('iframe',{staticClass:"huixin_iframe",attrs:{"frameborder":"0","scrolling":"auto","id":"courseIframe","height":"960","src":_vm.iframeSrc,"allowfullscreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }